import React, { useState } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

const VetStartedSOAPSection = ({
  id,
  letter,
  title,
  subtitle,
  accentBg,
  accentColor,
  children,
  defaultOpen = false,
  badge,
  customButton,
  isExpanded = true,
  onToggle, // New prop for toggle handler
}) => {
  // ⭐ COMMENTED OUT — no longer using collapse/expand state.
  // The parent (VetStartedSOAPTabsInner) now only mounts one section at a
  // time, so this section is always "open" whenever it's rendered.
  // If you ever want accordion behavior back, uncomment this block and
  // restore the <button onClick={handleToggle}> wrapper + chevron below.

  // const [internalOpen, setInternalOpen] = useState(defaultOpen);
  // const isOpen = onToggle ? isExpanded : internalOpen;

  // const handleToggle = () => {
  //   if (onToggle) {
  //     onToggle(); // Use parent's toggle handler
  //   } else {
  //     setInternalOpen(!internalOpen); // Use internal state
  //   }
  // };

  return (
    <section id={id} className="scroll-mt-2">
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        {/* ⭐ CHANGED — was a <button onClick={handleToggle}> with a chevron.
            Now it's a static, non-interactive header div since there's
            nothing left to toggle. */}
        <div
          // type="button"
          // data-nav-tab="true"
          // onClick={handleToggle}
          className="w-full flex items-center gap-3.5 px-5 py-3.5"
          // className="w-full flex items-center gap-3.5 px-5 py-3.5 hover:bg-slate-50/80 transition-colors text-left group"
        >
          <span
            className="w-8 h-8 rounded-lg flex items-center justify-center text-[13px] font-black shrink-0"
            // className="w-8 h-8 rounded-lg flex items-center justify-center text-[13px] font-black shrink-0 transition-transform group-hover:scale-105"
            style={{ backgroundColor: accentBg, color: accentColor }}
          >
            {letter}
          </span>

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2.5 flex-wrap">
              <h3 className="text-[14px] font-bold text-slate-900 tracking-tight">
                {title}
              </h3>
              {badge != null && badge !== "" && (
                <span
                  className="text-[10px] font-bold px-2.5 py-0.5 rounded-full border"
                  style={{
                    backgroundColor: `${accentColor}12`,
                    color: accentColor,
                    borderColor: `${accentColor}25`,
                  }}
                >
                  {badge}
                </span>
              )}
            </div>
            {subtitle && (
              <p className="text-[11px] text-slate-400 mt-0.5 font-medium">
                {subtitle}
              </p>
            )}
          </div>

          <div className="flex items-center gap-2 shrink-0">
            {customButton && (
              <div onClick={(e) => e.stopPropagation()}>
                {customButton}
              </div>
            )}

            {/* ⭐ COMMENTED OUT — chevron toggle icon, no longer needed */}
            {/* {isOpen ? (
              <ChevronDownIcon className="w-4 h-4 text-slate-400" />
            ) : (
              <ChevronRightIcon className="w-4 h-4 text-slate-400" />
            )} */}
          </div>
        </div>

        <div
          className="h-0.5 w-full transition-all duration-200"
          // ⭐ CHANGED — was `opacity: isOpen ? 0.25 : 0`. Always shown now
          // since the section is never collapsed.
          style={{ backgroundColor: accentColor, opacity: 0.25 }}
        />

        {/* ⭐ CHANGED — was `{isOpen && (...)}`. Content always renders now
            since the parent only mounts this component when it's the
            active tab. */}
        {/* {isOpen && ( */}
          <div className="px-3 pb-3 pt-2 bg-white">
            {children}
          </div>
        {/* )} */}
      </div>
    </section>
  );
};

export default VetStartedSOAPSection;